import React from 'react';

interface CheckModuleProps {
  onCheckTypeSelect: (type: string) => void;
}

export default function CheckModule({ onCheckTypeSelect }: CheckModuleProps) {
  const checkTypes = [
    { label: '查小区', type: 'community', icon: 'ri-home-4-line', iconColor: 'text-emerald-600', bgColor: 'bg-emerald-50' },
    { label: '查商铺', type: 'shop', icon: 'ri-store-2-line', iconColor: 'text-violet-600', bgColor: 'bg-amber-50' },
    { label: '查园区', type: 'park', icon: 'ri-building-3-line', iconColor: 'text-amber-600', bgColor: 'bg-violet-50' },
    { label: '查企业', type: 'enterprise', icon: 'ri-briefcase-4-line', iconColor: 'text-blue-600', bgColor: 'bg-blue-50' },
    { label: '查商圈', type: 'businessDistrict', icon: 'ri-shopping-bag-3-line', iconColor: 'text-rose-600', bgColor: 'bg-rose-50' },
    // { label: '查社区', type: 'neighborhood', icon: 'ri-team-line', iconColor: 'text-cyan-600', bgColor: 'bg-cyan-50' }
  ];

  return (
    <div className="absolute top-20 right-80 z-[39] flex items-center gap-2">
      {checkTypes.map((item) => (
        <button
          key={item.type}
          onClick={() => onCheckTypeSelect(item.type)}
          className={`flex items-center gap-2 px-3 py-2 bg-white hover:bg-slate-50 text-slate-700 text-sm transition-all duration-200 cursor-pointer whitespace-nowrap rounded-lg border border-slate-200 hover:border-slate-300 shadow-sm`}
        >
          <div className={`w-6 h-6 rounded-md ${item.bgColor} flex items-center justify-center`}>
            <i className={`${item.icon} text-sm ${item.iconColor}`}></i>
          </div>
          <span className="font-medium">{item.label}</span>
        </button>
      ))}
    </div>
  );
}